import React from 'react';
import { prop } from 'ramda';
import { usePageSelector } from 'js/store/hooks';
import style from './StickySearch.scss';
import { dispatcher } from 'dispatcher';

export const StickyDesktopSearch = () => {
    const portlets = usePageSelector(prop('portlets'));
    const isResponsibleGamesPage = portlets && portlets.find(el => el.portletType === 'responsivegames');
    const isSearch = isResponsibleGamesPage && isResponsibleGamesPage.config.showSearch;
    const clickSearch = (e) => {
        e.preventDefault();
        const searchElement = document.getElementById('swiss_search');

        if (searchElement && !searchElement.classList.contains('activeSearch')) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            dispatcher.dispatch('search:applyActive');
        }
    };

    return (
        <div className={`${style.container} ${isSearch ? style.twoComponents : style.oneComponent} cms-sticky-desktop-search`}
                id={'sticky_search'}>
            <div className={style.content}>
                {isSearch &&
                    <div className={style.searchContainer} onClick={clickSearch}>
                        <div className={style.search}>
                        </div>
                    </div>
                }
                <div className={style.chatContainer}>
                    <div className={style.chat} id={'swiss_chat'}></div>
                </div>
            </div>
        </div>
    );
};
